module.exports = __webpack_public_path__ + "img/Icon - WINS.7a2207b7.png";